// extracted by mini-css-extract-plugin
export default {"pieDoughnutTable":"BAnalysisPieDoughnutTable-module_pieDoughnutTable_eb1de9bc"};